import { apiClient } from './client';

// プロジェクトが持つ「メモ」「タスク」。会話（スレッド）ではなく、内容を常に上書きで
// 管理する情報。デバイス固有ではなくプロジェクト（＝こねっこ）に紐づく。

export interface Memo {
  id: number;
  projectId: number;
  title: string;
  content: string;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface Task {
  id: number;
  projectId: number;
  title: string;
  content: string;
  done: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

// ── メモ ──
export async function listMemos(projectId: number): Promise<Memo[]> {
  const { data } = await apiClient.get(`/api/admin/projects/${projectId}/memos`);
  return data;
}

export async function createMemo(
  projectId: number,
  body: { title: string; content?: string },
): Promise<Memo> {
  const { data } = await apiClient.post(`/api/admin/projects/${projectId}/memos`, body);
  return data;
}

// 会話ではないので内容は上書き保存。
export async function updateMemo(
  id: number,
  body: { title?: string; content?: string; sortOrder?: number },
): Promise<Memo> {
  const { data } = await apiClient.patch(`/api/admin/memos/${id}`, body);
  return data;
}

export async function deleteMemo(id: number): Promise<{ ok: boolean }> {
  const { data } = await apiClient.delete(`/api/admin/memos/${id}`);
  return data;
}

// ── タスク ──
export async function listTasks(projectId: number): Promise<Task[]> {
  const { data } = await apiClient.get(`/api/admin/projects/${projectId}/tasks`);
  return data;
}

export async function createTask(
  projectId: number,
  body: { title: string; content?: string; done?: boolean },
): Promise<Task> {
  const { data } = await apiClient.post(`/api/admin/projects/${projectId}/tasks`, body);
  return data;
}

// 会話ではないので内容は上書き保存。
export async function updateTask(
  id: number,
  body: { title?: string; content?: string; done?: boolean; sortOrder?: number },
): Promise<Task> {
  const { data } = await apiClient.patch(`/api/admin/tasks/${id}`, body);
  return data;
}

export async function deleteTask(id: number): Promise<{ ok: boolean }> {
  const { data } = await apiClient.delete(`/api/admin/tasks/${id}`);
  return data;
}
